module.exports = __webpack_public_path__ + "media/video_particular.258fc605.mp4";